import React from 'react';
import { IconButton, Tooltip, Box, Typography } from '@mui/material';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { useTranslation } from 'react-i18next';

const ListButton = ({ isInList, onClick, size = 'small', activeListName = null }) => {
  const { t } = useTranslation();

  const getTooltipContent = () => {
    if (activeListName) {
      return (
        <Box>
          <Typography variant="caption" display="block" fontWeight="bold">
            {t('dataCatalog.actions.quickAddEnabled')}
          </Typography>
          <Typography variant="caption" display="block">
            {t('dataCatalog.actions.addToNamedList', { list: activeListName })}
          </Typography>
        </Box>
      );
    }
    return isInList
      ? t('dataCatalog.actions.inLists')
      : t('dataCatalog.actions.addToLists');
  };

  return (
    <Tooltip title={getTooltipContent()}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        size={size}
        color={activeListName ? 'primary' : (isInList ? 'primary' : 'default')}
        sx={{
          backgroundColor: activeListName ? 'primary.lighter' : undefined,
          '&:hover': {
            backgroundColor: activeListName ? 'primary.light' : undefined,
          }
        }}
      >
        {activeListName ? <PlaylistAddCheckIcon /> : (isInList ? <PlaylistAddCheckIcon /> : <PlaylistAddIcon />)}
      </IconButton>
    </Tooltip>
  );
};

export default ListButton;
